// Квадратная кнопка с иконкой (components/IconButton/README.md): aria-label и подсказка с клавишей.
import type { ButtonHTMLAttributes, Ref } from 'react';
import { cx } from '../lib/cx.ts';
import { Icon } from '../lib/icon.tsx';
import type { LucideIcon } from '../lib/icon.tsx';
import type { Shortcut } from './Kbd.tsx';
import { Tooltip } from './Tooltip.tsx';

export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'children'
> {
  icon: LucideIcon;
  /** Название действия: и aria-label, и текст подсказки. */
  label: string;
  /** Клавиша действия в подсказке: «Скрыть меню [». */
  shortcut?: Shortcut;
  size?: 'md' | 'sm';
  /** Нажатое состояние: фон color-canvas, aria-pressed. */
  pressed?: boolean;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  ref?: Ref<HTMLButtonElement>;
}

export function IconButton({
  icon,
  label,
  shortcut,
  size = 'md',
  pressed,
  tooltipSide,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <Tooltip content={label} shortcut={shortcut} side={tooltipSide}>
      <button
        type={type}
        aria-label={label}
        aria-pressed={pressed}
        className={cx('t-ibtn', size === 'sm' && 't-ibtn-sm', pressed && 'on', className)}
        {...rest}
      >
        <Icon icon={icon} />
      </button>
    </Tooltip>
  );
}
